import { oc } from '@orpc/contract';
import { productsInputSchema, productsOutputSchema } from '../schemas/board.schemas.js';
/** A read, sent as POST because its input carries the nested `period` union (like `board.stageSheets`). */
export const getProductsContract = oc
    .route({
    method: 'POST',
    path: '/board/products',
    tags: ['Board'],
    summary: 'Per-model vehicles sold and delivered over a period, each the total of its bound KPI; unbound → null (every role)',
})
    .input(productsInputSchema)
    .output(productsOutputSchema);
//# sourceMappingURL=get-products.contract.js.map